<template>
  <div
    class="context-menu relative"
    :class="{
      'option-buttons': shouldShowContextMenu
    }"
    @click="shouldShowContextMenu = !shouldShowContextMenu"
  >
    <i class="fal fa-ellipsis-v-alt fw text-3xl"></i>

    <div class="options" v-show="shouldShowContextMenu">
      <a
        class="option"
        :key="item.name"
        @click="item.clickAction"
        v-for="item in contextMenuItems"
      >
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
import { ContextMenuItem } from "../helper-classes/ContextMenuItem";

export default {
  name: "ContextMenu",
  props: {
    initialShouldShowContextMenu: {
      type: Boolean,
      default: false
    },
    contextMenuItems: {
      validator: function(value) {
        if (!Array.isArray(value)) {
          return false;
        }

        value.forEach(item => {
          if (!(item instanceof ContextMenuItem)) {
            return false;
          }
        });

        return true;
      },
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      shouldShowContextMenu: this.initialShouldShowContextMenu
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
$optionsButtonMinHeight: 44px;

.context-menu {
  .options {
    border-radius: 5px;
    @apply absolute top-1 right-0 border border-red mr-2 z-30;

    .option {
      @apply flex justify-center items-center capitalize text-sm bg-white px-8 py-4 leading-tight uppercase;

      &:not(:first-child) {
        @apply border-t border-red;
      }

      &:first-child {
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
      }

      &:last-child {
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
      }
    }
  }
}
</style>
